<template>
  <div class="container">
    <div
      :class="`header-wrap-height ${getSelectedProject ? 'header-wrap-height__project' : ''}`"
      ></div>
    <div class="header-wrap">
      <Header />
      <Breadcrumbs v-if="getSelectedProject" />
    </div>
    <div
      :class="{editor: true, sidebarIsActive: sidebarActivities.media || sidebarActivities.markers }"
    >
      <!-- <MediaSidebar v-if="getSelectedProject" /> -->
      <router-view />
      <MarkersSidebar v-if="getSelectedProject" />
    </div>
    <AddMarkPopup v-if="popupActivities.addMark" />
    <AddMediaPopup v-if="popupActivities.addMedia" />
    <AddPagePopup v-if="popupActivities.addPage" />
    <SharePopup v-if="popupActivities.share" />
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import Header from "../../components/Dashboard/Header";
import Breadcrumbs from "../../components/Dashboard/Breadcrumbs";
// import MediaSidebar from "../../components/Dashboard/Sidebars/Media";
import MarkersSidebar from "../../components/Dashboard/Sidebars/Markers";

import AddMarkPopup from "../../components/Dashboard/Popups/AddMark";
import AddMediaPopup from "../../components/Dashboard/Popups/AddMedia";
import AddPagePopup from "../../components/Dashboard/Popups/AddPage";
import SharePopup from "../../components/Dashboard/Popups/Share";

export default {
  computed: {
    ...mapState(["selectedProject", "sidebarActivities", "popupActivities"]),
    ...mapGetters(["getSelectedProject"])
  },
  methods: {
    ...mapMutations(["setSelectedProject", "setSelectedScene"]),
  },
  mounted() {
    this.setSelectedProject(null);
    this.setSelectedScene(null);
  },
  components: {
    Header,
    Breadcrumbs,
    MarkersSidebar,
    // MediaSidebar,
    AddMarkPopup,
    AddMediaPopup,
    AddPagePopup,
    SharePopup
  }
};
</script>

<style lang="scss">
.header-wrap {
  position: fixed;
  top: 0;
  width: 100%;
  border-bottom: 1.5px solid #c4c4cb;
  z-index: 101;

  &-height {
    height: 96px;

    &__project {
      height: 194px;
    }
  }
}

.container {
  width: 100%;
  min-height: 100%;
}

.editor {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  min-height: 100%;
  background-color: #dadade;
  padding: 0 30px;

  .sidebar + .container {
    width: 100%;
  }

  // &.sidebarIsActive {
  //   > .sidebar + .container {
  //     width: calc(50% - 30px);
  //   }
  // }
}

.sidebar {
  position: fixed;
  left: 0;
  min-width: 30px;
  height: calc(100% - 194px);

  &.sidebarRight {
    left: auto;
    right: 0;
  }

  &__content {
    display: flex;
    flex-direction: column;
    padding: 50px 20px 50px 50px;
    height: 100%;
    overflow-y: auto;
  }

  &__actions {
    margin: 45px 0;
  }
}

.title {
  &--small {
    font-size: 23px;
    font-weight: 500;
    color: #00bfff;
  }
}

.sidebar.sidebarActive {
  background-color: rgba(0, 0, 0, 0.75px);
  // width: calc(100% - 30px);
  width: 100%;
  z-index: 100;

  .sidebar-wrap {
    background-color: #e8e8eb;
    padding-right: 30px;
    position: relative;
    min-width: 50%;
    max-width: 50%;
    height: 100%;
  }

  &.sidebarRight {
    left: auto;
    right: 0;
    padding-left: 30px;

    .sidebar-wrap {
      margin-left: auto;
    }
  }
}

.button {
  border: 1px solid #b4b5be;
  background-color: #fff;
  color: #424242;
  float: left;
  font-size: 18px;
  padding: 0 10px;
  padding-right: 30px;
  min-height: 50px;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
    cursor: pointer;
  }

  &--fluid {
    border-radius: 3px;
    min-width: 195px;
    padding: 0 10px;
    align-self: center;
  }

  &--info {
    border: none;
    background-color: #00bfff;
    color: #fff;
  }

  &--add {
    position: relative;
    color: #919199;
    background-color: #f4f4f5;
    border: 1px solid #b5b5be;
    padding-right: 50px;

    &:hover {
      color: darken(#919199, 10%);
      background-color: darken(#f4f4f5, 10%);
    }

    &::after,
    &::before {
      content: "";
      position: absolute;
      width: 16px;
      height: 1.75px;
      background-color: #919199;
      right: 10px;

      top: 50%;
      transform: translateY(-50%);
    }

    &::after {
      transform: translateY(-50%) rotate(90deg);
    }
  }

  &--icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 50px;
    height: 50px;
    padding: 0 10px;
  }

  &--delete-mark {
    width: auto;
    white-space: nowrap;

    img {
      padding-right: 10px;
    }
  }
}

.label {
  color: #4c4c4c;
  font-size: 18px;
  margin-bottom: 5px;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #b8b8b8;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #b8b8b8;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #b8b8b8;
}

.input {
  border: none;
  background-color: #fff;
  font-size: 20px;
  padding-left: 20px;
  border-radius: 0;
  min-height: 50px;
  width: 100%;

  &--outline {
    border: 1px solid #bfbfbf;
    border-radius: 3px;
  }

  &--file {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: url('../../assets/editor/file-input-icon.svg');
    background-repeat: no-repeat;
    background-position: 10px;

    input[type="file"] {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }

    input[type="text"] {
      position: absolute;
      background-color: transparent;
      padding-left: 50px;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      opacity: 1;
    }

    .file-label {
      color: #b8b8b8;
      font-size: 20px;
    }
  }
}

textarea.input {
  padding-top: 15px;
  min-height: 180px;
  border: none;

  &--outline {
    border: 1px solid #bfbfbf;
    border-radius: 3px;
  }
}

.field {
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;

  &.actions {
    flex-direction: row;
    justify-content: flex-end;
  }

  &:last-of-type {
    margin-bottom: 0;
  }
}

.editor-popup {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.75);

  &__close {
    position: absolute;
    cursor: pointer;
    top: 20px;
    right: 20px;
    width: 40px;
    height: 40px;

    &::before,
    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(45deg);
      width: 32px;
      height: 2px;
      background-color: #b8b8b8;
    }

    &::before {
      transform: translate(-50%, -50%) rotate(-45deg);
    }
  }

  &__title {
    font-size: 40px;
    color: #00bfff;
    text-align: center;
    margin-bottom: 40px;
    margin-top: 0;
    font-weight: 300;
    width: 100%;

    &--marker {
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        max-width: 50px;
      }
    }
  }

  &__content {
    position: relative;
    background-color: #fff;
    border-radius: 3px;
    padding: 40px 100px;
    min-width: 615px;

    &-type {
      display: flex;
      align-items: center;

      img {
        margin-right: 10px;
      }
    }
  }

  .type__button {
    cursor: pointer;
  }
}
</style>
